const Item = (props) => {
  return (
    <div className="relative overflow-hidden small:flex-none small:p-3 med:p-2 med:w-[40vw] large:w-[20vw] ">
      <img
        src={props.img}
        alt="products"
        className="small:w-[70vw] small:h-[20vh] object-cover rounded-t-xl"
      />
      <img
        src={props.new}
        className="absolute mt-[-19vh] small:ml-[65%] med:ml-[72%] large:ml-[70%] h-[25%] object-cover animate-pulse "
      />

      <div className="rounded-b-xl bg-white flex items-center flex-col h-[12vh]">
        <h2 className="text-black mt-1 text-sm">{props.name}</h2>
        <h3 className="text-black  text-sm">{props.desc}</h3>
        <h3 className="text-black  text-sm">{props.desc2}</h3>
        <h4 className="text-orange-400 Bebas">{props.price}</h4>
      </div>
    </div>
  );
};

export default Item;
